import React from "react";
import {Outlet} from "react-router-dom";

const GuestLayout = () => {
  return (
    <div>
      <div>Guest Layout</div>
      <Outlet />
    </div>
  )
}

export default GuestLayout
